// Visual indicator for Apollo customer status. Single source of truth
// for the green-check / neutral pattern used across the directory.

export default function ApolloBadge({ isCustomer, size = 'sm' }) {
  if (isCustomer) {
    return (
      <span
        className={`directory-badge directory-badge--apollo directory-badge--${size}`}
        title="Apollo currently tows for this property"
      >
        <span className="directory-badge__icon" aria-hidden="true">&#10003;</span>
        <span className="directory-badge__label">Apollo customer</span>
      </span>
    );
  }
  return (
    <span className={`directory-badge directory-badge--neutral directory-badge--${size}`}>
      <span className="directory-badge__label">Not currently a customer</span>
    </span>
  );
}
